import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { toast } from 'sonner'

import { fileUploadToast } from '@/components/molecules/custom-async-toasts'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'

export const Route = createFileRoute('/_authenticated/(developer)/design-system')({
  component: DesignSystemPage,
})

function DesignSystemPage() {
  const [isAsyncButtonLoading, setIsAsyncButtonLoading] = useState(false)

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Typography</h2>
      <div className="mb-10 flex flex-col gap-4">
        <p className="font-body text-2xl leading-tight font-bold">
          Heading 1 font-size: 22px / 2xl <span className="mx-4 text-text-placeholder">|</span>{' '}
          line-height: 1.25 / tight <span className="mx-4 text-text-placeholder">|</span>{' '}
          font-weight: 700 / bold
        </p>
        <p className="font-body text-xl leading-tight font-bold">
          Heading 2 font-size: 20px / xl <span className="mx-4 text-text-placeholder">|</span>{' '}
          line-height: 1.25 / tight <span className="mx-4 text-text-placeholder">|</span>{' '}
          font-weight: 600 / semi-bold
        </p>
        <p className="font-body text-lg leading-tight font-semibold">
          Heading 3 font-size: 18px / lg <span className="mx-4 text-text-placeholder">|</span>{' '}
          line-height: 1.25 / tight <span className="mx-4 text-text-placeholder">|</span>{' '}
          font-weight: 600 / semi-bold
        </p>
        <p className="font-body text-base leading-tight font-semibold">
          Heading 4 font-size: 16px / base <span className="mx-4 text-text-placeholder">|</span>{' '}
          line-height: 1.25 / tight <span className="mx-4 text-text-placeholder">|</span>{' '}
          font-weight: 600 / semi-bold
        </p>
        <p className="font-body text-base leading-normal font-normal">
          Body 1 font-size: 16px / base <span className="mx-4 text-text-placeholder">|</span>{' '}
          line-height: 1.5 / normal <span className="mx-4 text-text-placeholder">|</span>{' '}
          font-weight: 400 / normal
        </p>
        <p className="font-body text-sm leading-normal font-normal">
          Body 2 font-size: 14px / sm <span className="mx-4 text-text-placeholder">|</span>{' '}
          line-height: 1.5 / normal <span className="mx-4 text-text-placeholder">|</span>{' '}
          font-weight: 400 / normal
        </p>
        <p className="font-body text-sm leading-normal font-semibold">
          Label 1 font-size: 14px / sm <span className="mx-4 text-text-placeholder">|</span>{' '}
          line-height: 1.5 / normal <span className="mx-4 text-text-placeholder">|</span>{' '}
          font-weight: 500 / medium
        </p>
        <p className="font-body text-xs leading-normal font-semibold">
          Label 2 font-size: 12px / xs <span className="mx-4 text-text-placeholder">|</span>{' '}
          line-height: 1.5 / normal <span className="mx-4 text-text-placeholder">|</span>{' '}
          font-weight: 500 / medium
        </p>
      </div>
      <h2 className="text-2xl font-bold mb-4">Buttons & Toasts</h2>
      <div className="mb-10 flex flex-wrap gap-4">
        <div className="bg-layer-1 flex p-4 flex-wrap gap-4 rounded border border-border-subtle-1">
          <Button variant="default">Button Primary</Button>
          <Button variant="neutral">Button Neutral</Button>
          <Button variant="background">Button Background</Button>
          <Button variant="outline">Button Outline</Button>
          <Button variant="ghost">Button Ghost</Button>
          <Input placeholder="Text Input" />
        </div>
        <Input variant="field-1" placeholder="Text Input" />
        <Button
          isLoading={isAsyncButtonLoading}
          onClick={async () => {
            setIsAsyncButtonLoading(true)
            await new Promise(res => setTimeout(res, 2000))
            setIsAsyncButtonLoading(false)
          }}
        >
          Async Button
        </Button>
        <Button onClick={() => toast.success('Success toast!')}>Toast Success</Button>
        <Button onClick={() => toast.error('Error toast!')}>Toast Error</Button>
        <Button onClick={() => toast.warning('Warning toast!')}>Toast Warning</Button>
        <Button onClick={() => toast.info('Info toast!')}>Toast Info</Button>
        <Button onClick={() => toast('Default toast!')}>Toast Default</Button>
        <Button onClick={() => fileUploadToast(new Promise(res => setTimeout(res, 2000)))}>
          Toast Upload (success)
        </Button>
        <Button onClick={() => fileUploadToast(new Promise((_, rej) => setTimeout(rej, 2000)))}>
          Toast Upload (fail)
        </Button>
      </div>
      <div className="bg-background border border-border-subtle-0 p-4 gap-8 flex flex-col">
        <span>Layer 0</span>
        <div className="bg-layer-1 hover:bg-layer-1-hover border border-border-subtle-1 p-4 gap-8 flex flex-col">
          <span>Layer 1</span>
          <div className="bg-layer-2 hover:bg-layer-2-hover border border-border-subtle-2 p-4 gap-8 flex flex-col">
            <span>Layer 2</span>
            <div className="bg-layer-3 hover:bg-layer-3-hover border border-border-subtle-3 p-4">
              <span>Layer 3</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
